// all_zoom_setting 데이터 구조 정의
export const defaultZoomSettings = {
  allowRanking: 30,
  adminNotification: [1],
  depositAccount: "",
  invoiceAccount: "",
  contactInfo: "",
  kakaoChannelId: "",
  end_submit: "16:00", // 주문 마감 시간 (기본값: 16:00, 평일)
  end_submit_sat: "16:00", // 주문 마감 시간 (토요일, 미설정 시 end_submit로 대체)
  end_submit_sun: "16:00", // 주문 마감 시간 (일요일, 미설정 시 end_submit로 대체)
  end_submit_sat_off: false, // true면 토요일은 휴무일로 처리 (시작일이 다음 영업일로 밀림)
  end_submit_sun_off: false, // true면 일요일은 휴무일로 처리 (시작일이 다음 영업일로 밀림)
  defaultAdRates: {
    banner: 0,
    popup: 0,
    video: 0,
  },
};

// 데이터 유효성 검사 함수
export const validateZoomSettings = (data) => {
  if (!data) return false;

  const requiredFields = [
    "allowRanking",
    "adminNotification",
    "depositAccount",
    "invoiceAccount",
    "contactInfo",
    "kakaoChannelId",
    "end_submit", // 주문 마감 시간 필드 추가
    "defaultAdRates",
  ];

  // 필수 필드 존재 여부 확인 (값이 없어도 필드 자체는 있어야 함)
  for (const field of requiredFields) {
    if (data[field] === undefined || data[field] === null) {
      return false;
    }
  }

  // end_submit(평일/토/일) 시간 형식 검증 (HH:MM 형식). 토/일 값은 아직 없을 수 있어 필수 필드로 넣지 않음
  const timeRegex = /^([0-1]?[0-9]|2[0-3]):[0-5][0-9]$/;
  for (const field of ["end_submit", "end_submit_sat", "end_submit_sun"]) {
    if (data[field] && typeof data[field] === "string") {
      if (!timeRegex.test(data[field])) {
        return false;
      }
    }
  }

  // defaultAdRates 객체 확인 (빈 객체여도 허용)
  if (!data.defaultAdRates || typeof data.defaultAdRates !== "object") {
    return false;
  }

  // adminNotification 배열 확인 및 각 요소가 정수인지 검증
  if (!Array.isArray(data.adminNotification)) {
    return false;
  }

  // adminNotification 배열의 각 요소가 정수인지 확인
  for (const notificationId of data.adminNotification) {
    if (!Number.isInteger(notificationId)) {
      return false;
    }
  }

  return true;
};

// 주문 마감 시간 관련 유틸리티 함수들
export const timeUtils = {
  // 현재 시간이 마감 시간을 지났는지 확인
  isSubmitTimeExpired: (endSubmitTime) => {
    if (!endSubmitTime) return false;

    const now = new Date();
    const currentTime = `${String(now.getHours()).padStart(2, "0")}:${String(
      now.getMinutes()
    ).padStart(2, "0")}`;

    return currentTime >= endSubmitTime;
  },

  // 마감 시간까지 남은 시간 계산 (분 단위)
  getRemainingMinutes: (endSubmitTime) => {
    if (!endSubmitTime) return 0;

    const now = new Date();
    const [deadlineHour, deadlineMinute] = endSubmitTime.split(":").map(Number);
    const currentHour = now.getHours();
    const currentMinute = now.getMinutes();

    const deadlineTotalMinutes = deadlineHour * 60 + deadlineMinute;
    const currentTotalMinutes = currentHour * 60 + currentMinute;

    if (currentTotalMinutes >= deadlineTotalMinutes) {
      return 0; // 이미 만료됨
    }

    return deadlineTotalMinutes - currentTotalMinutes;
  },

  // 남은 시간을 HH:MM 형식으로 포맷팅
  formatRemainingTime: (endSubmitTime) => {
    const remainingMinutes = timeUtils.getRemainingMinutes(endSubmitTime);
    const hours = Math.floor(remainingMinutes / 60);
    const minutes = remainingMinutes % 60;

    return `${String(hours).padStart(2, "0")} : ${String(minutes).padStart(
      2,
      "0"
    )}`;
  },

  // 현재 시간 가져오기
  getCurrentTime: () => {
    const now = new Date();
    return `${String(now.getHours()).padStart(2, "0")}:${String(
      now.getMinutes()
    ).padStart(2, "0")}`;
  },
};
